var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavbarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(-28 -32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 4,
    height: 4,
    transform: "translate(28 32)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 4,
    height: 4,
    transform: "translate(28 40)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 4,
    height: 4,
    transform: "translate(28 48)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 4,
    height: 4,
    transform: "translate(36 32)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 4,
    height: 4,
    transform: "translate(36 40)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 4,
    height: 4,
    transform: "translate(36 48)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 4,
    height: 4,
    transform: "translate(44 32)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 4,
    height: 4,
    transform: "translate(44 40)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 4,
    height: 4,
    transform: "translate(44 48)",
    fill: "#787c7c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarIcon);
export default __webpack_public_path__ + "static/media/navbar-icon.87c39fd03d88dc61f8b59a0e857226b3.svg";
export { ForwardRef as ReactComponent };